import { render, staticRenderFns } from "./ProductWaiverCard.vue?vue&type=template&id=a5d735e6&"
import script from "./ProductWaiverCard.vue?vue&type=script&lang=js&"
export * from "./ProductWaiverCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports